<script>
    import { createEventDispatcher } from "svelte";
    import Notification from "./Notification.svelte";
    import SvgIcon from "../SVGIcon.svelte";
    import ZeroNotificationsImg from "$/images/error/0-Notifications.png";

    export let notifications = [];
    export let hasMoreNotifications = false;
    export let notificationsLoading = true;

    const dispatch = createEventDispatcher();
</script>

<div class="notifications-dialog">
    <span class="notifications-header"> Notifications </span>

    <div class="notifications-list">
        {#each notifications as notification (notification.id)}
            <Notification {notification} />
        {/each}

        {#if notificationsLoading}
            <div class="notification-loading-spinner">
                <SvgIcon
                    name="spinner"
                    color="#efedec"
                    viewbox="0 0 24 24"
                    strokeWidth="2"
                />
            </div>
        {:else if notifications.length === 0}
            <p class="no-notifications">
                <img
                    src={ZeroNotificationsImg}
                    alt="There are no notifications, yet"
                />
            </p>
        {:else if hasMoreNotifications}
            <button on:click={() => dispatch("loadMore")} class="load-more">
                Load more
            </button>
        {/if}
    </div>
</div>

<style>
    .notifications-dialog {
        @apply absolute right-0 z-50 flex max-h-96 w-64 flex-col overflow-clip rounded-xl border border-solid border-gray-200 bg-white shadow-xl;
    }

    .notifications-header {
        @apply sticky top-0 border-0 border-b border-solid border-gray-200 bg-gray-100 px-2 py-1 text-xs text-gray-600;
    }

    .notifications-list {
        @apply flex flex-col overflow-y-auto overflow-x-hidden;
    }

    .load-more {
        @apply bg-gray-100 px-2 py-1 text-sm;
    }

    .no-notifications {
        @apply bg-gray-100 px-2 py-6 text-sm;
    }

    .notification-loading-spinner {
        @apply mx-auto my-2 animate-spin;
    }
</style>
